<script setup>
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import BenefitServices from "@/api/services/benefit";
import CardBenefit from "@/components/shared/CardBenefit.vue";
import BenefitCDialog from "@/components/shared/BenefitCDialog.vue";
import { useHomeContentStore } from "@/app/stores/homeContentStore";
import { useUiStore } from "@/app/stores/uiStore";
import { onMounted, ref } from "vue";
import Notification from "@/utils/plugins/NotificationService";

const homeContentStore = useHomeContentStore();
const uiStore = useUiStore();
const benefits = ref([]);

onMounted(() => {
  homeContentStore.setBenefit(null);
  homeContentStore.setShowDialogBenefit(false);
  loadMiBenefits();
})

const loadMiBenefits = async () => {
  const params = {
    // itemsPerPage:this.itemsPerPage,
    // page:this.page,
    'active': true,
  };
  uiStore.startLoading();
  return BenefitServices.get(params).then(resp => {
    benefits.value = resp.data['hydra:member'];
  }).catch(error => {
    Notification.error(error);
  }).finally(() => {
    uiStore.stopLoading();
  });
}
</script>

<template>
  <div>
    <header-title title="Talento" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/heart-icon.svg" width="50" alt="">
      <div class="title-text ml-4">
        Mis beneficios
      </div>
    </div>
    <div class="benefits-list my-4 mx-2" :class="{ 'benefits-list--centered': benefits.length < 3 }">
      <CardBenefit v-for="b in benefits" :key="b.id" :benefit="b" />
    </div>
    <el-dialog title="" v-model="homeContentStore.showDialogBenefit" class="benefit-dialog" width="900" top="12px"
      :show-close="false" :lock-scroll="true" style="border-radius: 20px;">
      <BenefitCDialog @closeDialog="homeContentStore.showDialogBenefit = false" />
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
#icon-heart {
  fill: $bg-blue;
  width: 3%;
}

.benefits-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.benefits-list--centered {
  justify-content: center;
}

::v-deep(.el-dialog__body) {
  overflow-x: hidden !important;
}

:deep(.benefit-dialog .el-dialog__body) {
  background: #f3f0fb;
  overflow-y: visible;
  padding: 0;
}

:deep(.benefit-dialog .el-dialog) {
  max-width: calc(100vw - 24px);
  width: 900px !important;
}

@media (max-width: 767px) {
  .title-text {
    line-height: 1.1;
  }

  .benefits-list {
    justify-content: center;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  :deep(.benefit-dialog .el-dialog) {
    margin: 12px auto;
    width: calc(100vw - 24px) !important;
  }

}
</style>
